(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('CommissioneRuoloDeleteController',CommissioneRuoloDeleteController);

    CommissioneRuoloDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommissioneRuolo'];

    function CommissioneRuoloDeleteController($uibModalInstance, entity, CommissioneRuolo) {
        var vm = this;

        vm.commissioneRuolo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CommissioneRuolo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
